import { AssignedPlans } from '../api/workoutApi';
import { formatLocalDate } from '../../../../utils/formatLocalDate';
import { resolvePlanCategory } from './planCategory';

const DEFAULT_WINDOW_DAYS = 365;

/** Normalize API date strings to YYYY-MM-DD for inputs and comparisons. */
export function displayDate(value) {
  if (!value) return '';
  const str = String(value);
  return str.includes('T') ? str.split('T')[0] : str;
}

function wideDateRange(windowDays = DEFAULT_WINDOW_DAYS) {
  const today = new Date();
  const start = new Date(today);
  start.setDate(start.getDate() - windowDays);
  const end = new Date(today);
  end.setDate(end.getDate() + windowDays);
  return { start: formatLocalDate(start), end: formatLocalDate(end) };
}

function normalizeDuration(match) {
  if (!match) return null;
  return {
    duration_id: match.duration_id,
    start_date: match.start_date,
    end_date: match.end_date,
    total_plans: match.total_plans,
    weekday_count: match.weekday_count,
    weekdays: match.weekdays || [],
    title: match.title || match.name || match.plan_name || null,
  };
}

export function durationOverlapsRange(duration, startDate, endDate) {
  if (!duration || !startDate || !endDate) return false;
  const dStart = displayDate(duration.start_date);
  const dEnd = displayDate(duration.end_date);
  return dStart <= endDate && dEnd >= startDate;
}

/** Coach vs personal category for a duration, via its first nested plan (see planCategory.js). */
export function durationPlanCategory(duration, viewedClientId) {
  const plan = (duration?.weekdays || []).flatMap((d) => d.plans || []).find(Boolean);
  return resolvePlanCategory(plan, viewedClientId);
}

export async function fetchDurationsInWindow(
  get,
  { userId, eventTypeId, windowDays = DEFAULT_WINDOW_DAYS }
) {
  if (!userId || !eventTypeId) return [];
  const { start, end } = wideDateRange(windowDays);
  const response = await AssignedPlans(get, start, end, userId, eventTypeId);
  return response?.data?.durations || [];
}

export async function fetchDurationById(
  get,
  { userId, eventTypeId, durationId, windowDays = DEFAULT_WINDOW_DAYS }
) {
  if (!userId || !eventTypeId || !durationId) return null;
  const durations = await fetchDurationsInWindow(get, { userId, eventTypeId, windowDays });
  const match = durations.find((d) => String(d.duration_id) === String(durationId));
  return normalizeDuration(match);
}
